import { render, staticRenderFns } from "./PriceBusinessCustomer.vue?vue&type=template&id=d684675a&scoped=true&"
import script from "./PriceBusinessCustomer.vue?vue&type=script&lang=js&"
export * from "./PriceBusinessCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PriceBusinessCustomer.vue?vue&type=style&index=0&id=d684675a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684675a",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fprice-business-customer%2FPriceBusinessCustomer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports